import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import TableToolbox from '../../../components/TableToolbox';
import { Strings } from '../../../utils/strings';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import classNames from 'classnames';
import MediaImageContainer from '../../../components/MediaImageContainer';
import { useMediaQuery, CircularProgress, Grid } from '@mui/material';
import { icons } from '../../../utils/icons';
import Button from '../../../components/Button';
import ReportActionMenu from '../ActionMenu';
import {
  getErrorMessage,
  isAdmin,
  isClient,
  issueTypeArray,
  isSuperAdmin,
} from '../../../utils/appUtils';
import { connect } from 'react-redux';
import { getReport } from '../../../redux/actions/jobActions/reportActions/getReport';
import { confirmIssue } from '../../../redux/actions/jobActions/reportActions/confirmIssue';
import { useAlert } from 'react-alert';
import moment from 'moment';
import NewIssue from '../../Issues/NewIssue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import CustomRadioButton from '../../../components/CustomRadioButton';
import Textbox from '../../../components/Textbox';
import Dropdown from '../../../components/Dropdown';
import { CommonSwitch } from '../../../components/Switch';
import {
  updateReport,
  setUpdateReport,
} from '../../../redux/actions/jobActions/reportActions/updateReport';
import UploadFileWithTagsDialog from '../../../components/UploadFileWithTagsDialog';
import CommonDialog from '../../../components/CommonDialog';
import { downloadReport } from '../../../redux/actions/jobActions/reportActions/downloadReport';
import { markAsCompleteJob } from '../../../redux/actions/jobActions/reportActions/markAsCompleteJob';
import SendReport from '../../Jobs/SendReport';
import Checkbox from '../../../components/Checkbox';
import { useDispatch } from 'react-redux';
import DateSelector from '../../../components/DateSelector';
import { fetchCategoryList } from '../../../redux/actions/jobActions/categoryActions/categoryTypeList';
import DateTimeSelector from '../../../components/DateTimeSelector';

const IssueFoundDetailList = [
  { title: 'Issue Title', relation: 'issueTitle', output: 'textbox' },
  { title: 'Issue Type', relation: 'type', output: 'selection' },
  { title: 'Issue Category', relation: 'category', output: 'selection' },
  {
    title: 'Please explain the issue, along with solution',
    relation: 'description',
    output: 'textarea',
  },
  {
    title: 'If to be conducted by us, inform what supplies will be needed',
    relation: 'suppliesNeeded',
    output: 'textarea',
  },
  {
    title: 'Follow Up',
    relation: 'followUp',
    output: 'toggle',
  },
  {
    title: 'Discuss with admin',
    relation: 'discussWithAdmin',
    output: 'toggle',
  },
  // {
  //   title: 'Notes',
  //   relation: 'notes',
  //   output: 'textarea',
  // },
];

const ReportPropertyData = (props) => {
  const { title, value, datePickerValue } = props;
  const classes = useStyles();

  const onChangeAuditTrial = (value) => {
    const newReportData = {
      ...props.reportData,
      auditTitle: value,
    };
    props.updateReportData(newReportData);
  };

  const onChangeConductedOn = (value) => {
    const newReportData = {
      ...props.reportData,
      conductedOn: value,
    };
    props.updateReportData(newReportData);
  };
  return (
    <div
      className={
        props.classContainer
          ? props.classContainer
          : classes.report_property_container
      }
      style={{ marginRight: 0 }}
    >
      <label className={classes.text_dark_blue}>{title.toUpperCase()}</label>
      {!props.isEditReport ? (
        <label className={classes.text_common}>{value && value}</label>
      ) : title === Strings.CONDUCTED_ON ? (
        <DateTimeSelector
          name='conductedOn'
          onChange={(e) => {
            onChangeConductedOn(e);
          }}
          value={datePickerValue}
          format='MMM dd, yyyy hh:mm a'
          placeholder={Strings.SAMPLE_DATE}
          containerClassName={classes.date_selector_container}
        />
      ) : (
        // <DateSelector
        //   name='conductedOn'
        //   onChange={(e) => {
        //     onChangeConductedOn(e);
        //   }}
        //   value={value}
        //   format='MMM dd, yyyy'
        //   placeholder={Strings.SAMPLE_DATE}
        //   containerClassName={classes.date_selector_container}
        //   // minDate={new Date()}
        // />
        <Textbox
          onChange={(e) => onChangeAuditTrial(e.target.value)}
          value={value ? value : ''}
          placeholder={'Type Here'}
          disabled={!props.isEditReport}
          className={classes.form_input}
          containerClassName={classes.date_selector_container}
        />
      )}
    </div>
  );
};

const IssueSuppliesBox = (props) => {
  const { title, message } = props;
  const classes = useStyles();
  return (
    <div
      className={classNames(classes.flex_column_view, props.containerClassName)}
    >
      {title && <label className={classes.text_dark_blue}>{title}</label>}
      <div className={classes.issue_supply_box}>
        <label className={classes.text_common}>{message && message}</label>
      </div>
    </div>
  );
};

const InformationBox = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));
  const isTabletView = useMediaQuery(theme.breakpoints.down('md'));
  const isLaptopView = useMediaQuery(theme.breakpoints.down('lg'));

  const onClickNewMedia = (type, index, item) => {
    props.onClickOpenNewMediaDialog(
      type,
      index,
      item,
      props.reportElementsIndex
    );
  };

  const updateData = (elements) => {
    const newReportElements = props?.reportData?.reportElements?.map(
      (item, index) => {
        if (index === props.reportElementsIndex) {
          item.elements = elements;
        }
        return item;
      }
    );
    const newReportData = {
      ...props.reportData,
      reportElements: newReportElements,
    };
    props.updateReportData(newReportData);
  };

  const onChangeCustomRadioButton = async (id, option, mainIndex) => {
    let issueCountOfReportElement = '';
    let issueCountTotal = '';
    const newElements = props.data?.map((i, ind) => {
      if (ind === mainIndex) {
        const LastSelected = i?.options.filter((item) => item.selected);

        i?.options.map((item) => {
          if (item._id === id) {
            if (i?.elementType === 'Check List') {
              item.selected = !item.selected;
              // issueCountTotal = props?.reportData?.issueCount || 0;
            } else {
              // if (
              //   option === 'Issues found' &&
              //   !i.selected &&
              //   LastSelected[0]?.option !== 'Issues found'
              // ) {
              //   i.issueCount = i.issueCount + 1;
              //   props?.reportData?.reportElements?.map((item, index) => {
              //     if (index === props.reportElementsIndex) {
              //       issueCountOfReportElement = item.issueCount + 1;
              //     }
              //     return item;
              //   });
              //   issueCountTotal = props?.reportData.issueCount + 1;
              // } else if (
              //   LastSelected[0]?.option === 'Issues found' &&
              //   option !== 'Issues found'
              // ) {
              //   i.issueCount = i.issueCount - 1;
              //   props?.reportData?.reportElements?.map((item, index) => {
              //     if (index === props.reportElementsIndex) {
              //       issueCountOfReportElement = item.issueCount - 1;
              //     }
              //     return item;
              //   });
              //   issueCountTotal = props?.reportData.issueCount - 1;
              // } else {
              //   props?.reportData?.reportElements?.map((item, index) => {
              //     if (index === props.reportElementsIndex) {
              //       issueCountOfReportElement = item.issueCount;
              //     }
              //     return item;
              //   });
              //   issueCountTotal = props?.reportData.issueCount;
              // }
              item.selected = true;
            }
          } else {
            if (i?.elementType !== 'Check List') {
              item.selected = false;
            } else {
              item.selected = item.selected;
            }
          }
        });
      }
      return i;
    });

    const newReportElements = props?.reportData?.reportElements?.map(
      (item, index) => {
        if (index === props.reportElementsIndex) {
          item.elements = newElements;
          // item.issueCount = issueCountOfReportElement;
        }
        return item;
      }
    );
    const newReportData = {
      ...props.reportData,
      // issueCount: issueCountTotal,
      reportElements: newReportElements,
    };
    props.updateReportData(newReportData);
    // await updateData(newElements, isCountChange);
  };

  const onChangeTextBox = async (value, mainIndex) => {
    const newElements = props.data?.map((i, ind) => {
      if (ind === mainIndex) {
        i.text = value;
      }
      return i;
    });
    await updateData(newElements);
  };

  const onChangeTextForNotes = async (value, mainIndex) => {
    const newElements = props.data?.map((i, ind) => {
      if (ind === mainIndex) {
        i.notes = value;
      }
      return i;
    });
    await updateData(newElements);
  };

  const onChangeTextBoxForIssueFound = async (value, relation, mainIndex) => {
    let issueTotalCount = props.reportData.issueCount;
    const newElements = props.data?.map((i, ind) => {
      if (ind === mainIndex) {
        if (relation === 'issueFound') {
          i.issueCount = value === true ? i.issueCount + 1 : i.issueCount - 1;
        }
        i[relation] = value;
      }
      return i;
    });
    // await updateData(newElements);

    const newReportElements = props?.reportData?.reportElements?.map(
      (item, index) => {
        if (index === props.reportElementsIndex) {
          if (relation === 'issueFound') {
            item.issueCount =
              value === true
                ? item.issueCount + 1
                : item.issueCount <= 0
                ? 0
                : item.issueCount - 1;
          }
          item.elements = newElements;
        }
        return item;
      }
    );

    if (relation === 'issueFound') {
      issueTotalCount =
        value === true ? issueTotalCount + 1 : issueTotalCount - 1;
    }
    const newReportData = {
      ...props.reportData,
      issueCount: issueTotalCount <= 0 ? 0 : issueTotalCount,
      reportElements: newReportElements,
    };
    props.updateReportData(newReportData);
  };

  const handleDropdown = async (relation, value, mainIndex) => {
    const newElements = props.data?.map((i, ind) => {
      if (ind === mainIndex) {
        i[relation] = value;
      }
      return i;
    });
    await updateData(newElements);
  };

  const onChangeSwitch = async (relation, mainIndex) => {
    const newElements = props.data?.map((i, ind) => {
      if (ind === mainIndex) {
        i[relation] = !i[relation];
      }
      return i;
    });
    await updateData(newElements);
  };

  const onMediaActionClick = (action, imgId, mainIndex, tags) => {
    props.onClickReportMediaMenuClick(
      'innerData',
      action,
      imgId,
      mainIndex,
      props.reportElementsIndex,
      tags
    );
  };
  return (
    <>
      {props.data?.length > 0 &&
        props.data?.map((mainItem, mainIndex) =>
          (!isClient(props.paramJobId) && props.isEditReport)  ? (
            <>
              <div className={classes.report_elements_container}>
                <div
                  className={classes.information_data_title_container}
                  // style={{ marginBottom: isClient(props.paramJobId) && 20 }}
                >
                  <label
                    className={classes.information_common_title}
                    style={{ marginRight: 15 }}
                  >
                    {mainItem.title}
                  </label>
                  <div
                    className={classes.flex_view}
                    style={{
                      flexDirection: isClient(props.paramJobId)
                        ? 'column'
                        : 'row',
                    }}
                  >
                    {mainItem.issueCount > 0 &&
                      !mainItem.issueConfirmed &&
                      !props.paramJobId && (
                        <ReportActionMenu
                          id={mainItem._id}
                          confirmed={mainItem.issueConfirmed}
                          onSelect={(action, id) =>
                            props.actionOnClick(action, id, mainItem._id)
                          }
                        />
                      )}
                    {/* <label
                    className={classNames(
                      classes.issue_container,
                      mainItem.issueCount > 0 && classes.red_issue_container
                    )}
                    style={{ textAlign: 'center' }}
                  >
                    {mainItem.issueCount
                      ? `${mainItem.issueCount} ${Strings.ISSUES}${
                          +mainItem.issueConfirmed ? ' ' + Strings.APPROVED : ''
                        }`
                      : Strings.NO_ISSUE}
                  </label> */}

                    {mainItem?.issueCount > 0 && (
                      <label
                        className={classNames(
                          classes.issue_container,
                          mainItem?.issueCount > 0 &&
                            classes.red_issue_container
                        )}
                        style={{ cursor: 'pointer', textAlign: 'center' }}
                      >
                        {`${
                          mainItem?.issueCount +
                          ' ' +
                          Strings.ISSUES +
                          (mainItem.issueConfirmed
                            ? ' ' + Strings.APPROVED
                            : '')
                        }`}
                      </label>
                    )}
                    {/* {isClient(props.paramJobId) &&
                      mainItem?.options?.length > 0 &&
                      mainItem?.options
                        ?.filter((i) => i.selected)
                        .map((x) => (
                          <label
                            className={classNames(classes.issue_container)}
                            style={{
                              cursor: 'pointer',
                              textAlign: 'center',
                              background: x.color || '#ED4242',
                              maxWidth: 200,
                            }}
                          >
                            {x?.option}
                          </label>
                        ))} */}
                  </div>
                </div>
              </div>
              {/* {isClient(props.paramJobId) &&
                (mainItem?.notes ||
                  mainItem?.attachments.length > 0 ||
                  mainItem?.issueConfirmed) && (
                  <div
                    className={classes.report_elements_container1}
                    style={{
                      borderBottom:
                        mainIndex !== props.data?.length - 1 &&
                        `1px solid ${theme.palette.background_border}`,
                      paddingBottom: 0,
                      paddingTop: 0,
                    }}
                  >
                    <div
                      className={classes.detail_section}
                      style={{
                        width: '100%',
                        paddingBottom: mainItem?.attachments?.length > 0 && 20,
                        paddingTop: 0,
                      }}
                    >
                      {mainItem?.notes && (
                        <div style={{ marginBottom: 20 }}>
                          <ReportPropertyData
                            title={Strings.NOTES}
                            value={mainItem?.notes}
                          />
                        </div>
                      )}
                      <MediaImageContainer
                        isEditReport={props.isEditReport}
                        imageArray={mainItem?.attachments}
                        imageData={props?.imageData}
                        itemsPerRow={isMobileView ? 2 : isTabletView ? 3 : 5}
                        lg={3}
                        xl={1.5}
                        handleMediaActionClick={(action, imgId, tags) => {
                          onMediaActionClick(action, imgId, mainIndex, tags);
                        }}
                        paramJobId={props?.paramJobId}
                      />
                      {mainItem?.issueConfirmed && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            flexDirection: 'row',
                            gap: 10,
                          }}
                        >
                          <img src={icons().redFlagIcon} />
                          <label
                            className={classes.text_dark_blue}
                            style={{ fontSize: 13 }}
                          >
                            {Strings?.ITEM_ADDED_TO_ISSUES_MODULE?.toUpperCase()}
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                )} */}
              {/* {!isClient(props.paramJobId) && ( */}
              <div
                className={classes.report_elements_container1}
                style={{
                  borderBottom:
                    mainIndex !== props.data?.length - 1 &&
                    `1px solid ${theme.palette.background_border}`,
                }}
              >
                <div
                  className={classes.detail_section}
                  style={{
                    width: isClient(props.paramJobId) ? '100%' : '60%',
                  }}
                >
                  {mainItem?.options?.length !== 0 && ( // mainItem?.options.some((item) => item.selected)
                    <div className={classes.issue_found_detail}>
                      <div className={classes.issue_found_list}>
                        <label className={classes.information_common_title}>
                          {'Reported'}
                        </label>
                      </div>
                      <div className={classes.issue_found_desc}>
                        <div className={classes.radio_view}>
                          <Grid container>
                            {mainItem?.options?.map((item, ind) => {
                              return (
                                <Grid
                                  item
                                  xs={6}
                                  xl={4}
                                  style={{ marginBottom: 10 }}
                                >
                                  <CustomRadioButton
                                    value={item?.option}
                                    label={item?.option}
                                    disabled={!props.isEditReport}
                                    checked={item?.selected && item?.option}
                                    style={{
                                      marginLeft: 10,
                                    }}
                                    onChange={(value) =>
                                      onChangeCustomRadioButton(
                                        item._id,
                                        item.option,
                                        mainIndex
                                      )
                                    }
                                    containerStyle={
                                      classes.radio_containerStyle
                                    }
                                  />
                                </Grid>
                              );
                            })}
                          </Grid>
                        </div>
                      </div>
                    </div>
                  )}
                  {mainItem?.options?.length === 0 &&
                    mainItem?.elementType === 'Text Input' &&
                    (mainItem?.text || props.isEditReport) && (
                      <Textbox
                        onChange={(e) =>
                          onChangeTextBox(e.target.value, mainIndex)
                        }
                        // name={item.relation}
                        value={mainItem?.text ? mainItem?.text : ''}
                        placeholder={'Type Here'}
                        disabled={!props.isEditReport}
                        className={classes.form_input}
                      />
                    )}
                  {mainItem?.elementType !== 'Group' && (
                    <>
                      {(mainItem.notes || props.isEditReport) && (
                        <div className={classes.issue_found_detail}>
                          <div className={classes.issue_found_list}>
                            <label className={classes.information_common_title}>
                              {'Notes'}
                            </label>
                          </div>
                          <div className={classes.issue_found_desc}>
                            <Textbox
                              onChange={(e) =>
                                onChangeTextBoxForIssueFound(
                                  e.target.value,
                                  'notes',
                                  mainIndex
                                )
                              }
                              name={'notes'}
                              value={mainItem.notes ? mainItem.notes : ''}
                              placeholder={'Type Here'}
                              disabled={!props.isEditReport}
                              className={classes.form_input}
                              multiline={true}
                              rows={4}
                            />
                          </div>
                        </div>
                      )}
                      {(mainItem.issueFound || props.isEditReport) && (
                        <div className={classes.checkBoxMainContainer}>
                          <Checkbox
                            id='issueFound'
                            name='Issue Found'
                            checked={mainItem?.issueFound}
                            containerContainerClass={classes.checkboxContainer}
                            checkboxContainerClass={classes.list_checkbox}
                            checkedContainerClass={classes.checked_checkbox}
                            onChange={(e) => {
                              if (!props.paramJobId && props.isEditReport) {
                                onChangeTextBoxForIssueFound(
                                  !mainItem?.issueFound,
                                  'issueFound',
                                  mainIndex
                                );
                              }
                            }}
                          />
                          <label className={classes.information_common_title}>
                            {'Add To Issues'}
                          </label>
                        </div>
                      )}
                    </>
                  )}

                  {mainItem?.elementType !== 'Group' &&
                    mainItem.issueFound &&
                    IssueFoundDetailList.map((item) => {
                      return (
                        (mainItem[item.relation] || props.isEditReport) && (
                          <div className={classes.issue_found_detail}>
                            <div className={classes.issue_found_list}>
                              <label
                                className={classes.information_common_title}
                              >
                                {item.title}
                              </label>
                            </div>
                            <div className={classes.issue_found_desc}>
                              {item.output === 'selection' && (
                                <Dropdown
                                  name={item.relation}
                                  onChange={(e) => {
                                    handleDropdown(
                                      item.relation,
                                      e.target.value,
                                      mainIndex
                                    );
                                  }}
                                  value={
                                    mainItem[item.relation]
                                      ? mainItem[item.relation]
                                      : '0'
                                  }
                                  // label={Strings.TYPE}
                                  title={Strings.SELECT_AN_OPTION}
                                  optionArray={
                                    item.relation === 'category'
                                      ? props.vendorCategoryList
                                      : issueTypeArray
                                  }
                                  disabled={!props.isEditReport}
                                />
                              )}
                              {(item.output === 'textbox' ||
                                item.output === 'textarea') && (
                                <Textbox
                                  onChange={(e) =>
                                    onChangeTextBoxForIssueFound(
                                      e.target.value,
                                      item.relation,
                                      mainIndex
                                    )
                                  }
                                  name={item.relation}
                                  value={
                                    mainItem[item?.relation]
                                      ? mainItem[item?.relation]
                                      : ''
                                  }
                                  placeholder={'Type Here'}
                                  disabled={!props.isEditReport}
                                  className={classes.form_input}
                                  multiline={
                                    item.output === 'textarea' ? true : false
                                  }
                                  rows={4}
                                />
                              )}
                              {item.output === 'toggle' && (
                                <CommonSwitch
                                  checked={
                                    mainItem[item.relation]
                                      ? mainItem[item.relation]
                                      : false
                                  }
                                  onChange={(e) =>
                                    onChangeSwitch(item.relation, mainIndex)
                                  }
                                  inputProps={{ 'aria-label': 'ant design' }}
                                  disabled={!props.isEditReport}
                                />
                              )}
                            </div>
                          </div>
                        )
                      );
                    })}

                  {/* <div className={classes.issue_found_detail}>
                  <div className={classes.issue_found_list}>
                    <label className={classes.information_common_title}>
                      {Strings.NOTES}
                    </label>
                  </div>
                  <div className={classes.issue_found_desc}>
                    <Textbox
                      onChange={(e) =>
                        onChangeTextForNotes(e.target.value, mainIndex)
                      }
                      // name={item.relation}
                      value={mainItem?.notes ? mainItem?.notes : ''}
                      placeholder={mainItem?.notes === '' ? '--' : 'Type Here'}
                      disabled={!props.isEditReport}
                      multiline
                      rows={4}
                      className={classes.form_input}
                    />
                  </div>
                </div> */}
                </div>
                {/* {!isClient(props.paramJobId) && ( */}
                <div className={classes.media_section}>
                  {props.isEditReport && (
                    <div className={classes.new_media}>
                      <div
                        onClick={() => {
                          onClickNewMedia('innerData', mainIndex, mainItem);
                        }}
                        className={classes.new_media_container}
                      >
                        <img src={icons(theme).Plus} style={{ height: 20 }} />
                        <label className={classes.text_dark_blue}>
                          {Strings.NEW_MEDIA}
                        </label>
                      </div>
                    </div>
                  )}
                  <MediaImageContainer
                    isEditReport={props.isEditReport}
                    imageArray={mainItem?.attachments}
                    imageData={props?.imageData}
                    itemsPerRow={2}
                    sm={3}
                    md={6}
                    lg={6}
                    xl={4}
                    handleMediaActionClick={(action, imgId, tags) => {
                      onMediaActionClick(action, imgId, mainIndex, tags);
                    }}
                    isReport={true}
                    paramJobId={props?.paramJobId}
                  />
                </div>
                {/* )} */}
              </div>
              {/* )} */}
            </>
          ) : (
            <>
              <div
                className={classes.client_report_elements_container}
                style={
                  {
                    // paddingBottom:
                    //   mainItem?.notes ||
                    //   mainItem?.attachments.length > 0 ||
                    //   mainItem?.issueConfirmed
                    //     ? 15
                    //     : 0,
                    // backgroundColor: 'red'
                  }
                }
              >
                <div
                  className={classes.client_information_data_title_container}
                  style={{
                    borderTop:
                      mainIndex !== 0 &&
                      // (mainItem?.notes ||
                      //   mainItem?.attachments.length > 0 ||
                      //   mainItem?.issueConfirmed) &&
                      `1px solid ${theme.palette.background_border}`,
                    paddingBottom: mainItem?.attachments.length > 0 ? 15 : 0,
                  }}
                >
                  <label
                    className={classes.client_information_common_title}
                    style={{
                      marginRight: 15,
                      fontWeight: 600,
                      alignSelf: 'center',
                      paddingTop: mainItem?.options?.length === 0 && 8,
                      paddingBottom: mainItem?.options?.length === 0 && 8,
                    }}
                  >
                    {mainItem.title ? mainItem.title : ''}
                  </label>
                  <div
                    className={classes.flex_view}
                    style={{
                      flexDirection: 'column',
                    }}
                  >
                    {mainItem?.options?.length > 0 &&
                      mainItem?.options
                        ?.filter((i) => i.selected)
                        .map((x) => (
                          <label
                            className={classNames(
                              classes.client_issue_container
                            )}
                            style={{
                              cursor: 'pointer',
                              textAlign: 'center',
                              background: x.color || '#ED4242',
                              // maxWidth: 200,
                            }}
                          >
                            {x?.option}
                          </label>
                        ))}
                  </div>
                </div>
              </div>
              {mainItem?.issueConfirmed && (
                <div className={classes.issue_confirmed_container}>
                  <img src={icons().redFlagIcon} />
                  <label
                    className={classes.text_dark_blue}
                    style={{ fontSize: 13 }}
                  >
                    {Strings?.ITEM_ADDED_TO_ISSUES_MODULE?.toUpperCase()}
                  </label>
                </div>
              )}
              {(mainItem?.notes ||
                mainItem?.attachments.length > 0 ||
                mainItem?.issueConfirmed) && (
                <div
                  className={classes.client_report_elements_container1}
                  style={{
                    // borderBottom:
                    //   mainIndex !== props.data?.length - 1 &&
                    //   `1px solid ${theme.palette.background_border}`,
                    paddingBottom: 15,
                    paddingTop: 0,
                    marginTop: 15,
                  }}
                >
                  <div
                    className={classNames(
                      classes.client_detail_section,
                      classes.detail_width
                    )}
                    style={{
                      // width: '100%',
                      // paddingBottom: mainItem?.attachments?.length > 0 && 20,
                      paddingTop: 0,
                    }}
                  >
                    {mainItem?.notes && (
                      <div className={classes.client_notes_margin_btm}>
                        <ReportPropertyData
                          title={Strings.NOTES}
                          value={mainItem?.notes}
                          classContainer={
                            classes.client_report_property_container
                          }
                        />
                      </div>
                    )}
                    <MediaImageContainer
                      isEditReport={props.isEditReport}
                      imageArray={mainItem?.attachments}
                      imageData={props?.imageData}
                      itemsPerRow={isMobileView ? 2 : isTabletView ? 3 : 5}
                      lg={3}
                      xl={1.5}
                      handleMediaActionClick={(action, imgId, tags) => {
                        onMediaActionClick(action, imgId, mainIndex, tags);
                      }}
                      paramJobId={props?.paramJobId}
                    />
                  </div>
                </div>
              )}
            </>
          )
        )}
    </>
  );
};

const ReportInformation = (props) => {
  const {
    data,
    index,
    openInformation,
    reportData,
    updateReportData,
    isEditReport,
    onClickOpenNewMediaDialog,
    onClickReportMediaMenuClick,
    paramJobId,
    vendorCategoryList,
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));
  const isTabletView = useMediaQuery(theme.breakpoints.down('md'));
  const isLaptopView = useMediaQuery(theme.breakpoints.down('lg'));

  const updateData = (reportElements) => {
    const newReportData = {
      ...reportData,
      reportElements: reportElements,
    };
    updateReportData(newReportData);
  };

  const onChangeCustomRadioButton = async (id, option) => {
    let issueCountTotal = '';
    const newReportElements = reportData?.reportElements.map((i, ind) => {
      if (ind === index) {
        const LastSelected = i?.options.filter((item) => item.selected);
        i?.options.map((item) => {
          if (item._id === id) {
            if (data?.elementType === 'Check List') {
              item.selected = !item.selected;
              // issueCountTotal = reportData?.issueCount || 0;
            } else {
              // if (
              //   option === 'Issues found' &&
              //   !i.selected &&
              //   LastSelected[0]?.option !== 'Issues found'
              // ) {
              //   i.issueCount = i.issueCount + 1;
              //   issueCountTotal = reportData.issueCount + 1;
              // } else if (
              //   LastSelected[0]?.option === 'Issues found' &&
              //   option !== 'Issues found'
              // ) {
              //   i.issueCount = i.issueCount - 1;
              //   issueCountTotal = reportData.issueCount - 1;
              // } else {
              //   issueCountTotal = reportData.issueCount;
              // }
              item.selected = true;
            }
          } else {
            if (data?.elementType !== 'Check List') {
              item.selected = false;
            } else {
              item.selected = item.selected;
            }
          }
        });
      }
      return i;
    });
    const newReportData = {
      ...reportData,
      // issueCount: issueCountTotal,
      reportElements: newReportElements,
    };
    props.updateReportData(newReportData);
    // await updateData(newReportElements);
  };

  const onChangeTextBox = async (value) => {
    const newReportElements = reportData?.reportElements?.map((i, ind) => {
      if (ind === index) {
        i.text = value;
      }
      return i;
    });
    await updateData(newReportElements);
  };

  const onChangeTextForNotes = async (value) => {
    const newReportElements = reportData?.reportElements?.map((i, ind) => {
      if (ind === index) {
        i.notes = value;
      }
      return i;
    });
    await updateData(newReportElements);
  };

  const onChangeTextBoxForIssueFound = async (value, relation) => {
    let issueTotalCount = reportData.issueCount;
    const newReportElements = reportData?.reportElements.map((i, ind) => {
      if (ind === index) {
        if (relation === 'issueFound') {
          i.issueCount =
            value === true
              ? i.issueCount + 1
              : i.issueCount <= 0
              ? 0
              : i.issueCount - 1;
        }
        i[relation] = value;
      }
      return i;
    });
    if (relation === 'issueFound') {
      issueTotalCount =
        value === true ? issueTotalCount + 1 : issueTotalCount - 1;
    }
    const newReportData = {
      ...reportData,
      issueCount: issueTotalCount <= 0 ? 0 : issueTotalCount,
      reportElements: newReportElements,
    };

    updateReportData(newReportData);
  };

  const handleOpenInformation = () => {
    if (openInformation.findIndex((item) => item === index) === -1) {
      props.setOpenInformation([...openInformation, index]);
    } else {
      props.setOpenInformation(
        openInformation.filter((item) => item !== index)
      );
    }
  };

  const handleOnAction = (
    action,
    id,
    elementId,
    subElementId,
    isSubElement
  ) => {
    const elementData =
      isSubElement && subElementId
        ? reportData?.reportElements
            ?.filter((el) => el?._id === elementId)[0]
            ?.elements?.filter((el) => el?._id === subElementId)[0]
        : reportData?.reportElements?.filter((el) => el?._id === elementId)[0];
    const newData = {
      issueTitle: elementData?.issueTitle,
      dueDate: reportData?.createdAt,
      client: reportData?.client,
      job: reportData?.job?._id,
      type: elementData?.type,
      description: elementData?.description,
      suppliesNeeded: elementData?.suppliesNeeded,
      discussWithAdmin: elementData?.discussWithAdmin || false,
      followUp: elementData?.followUp || false,
      property: { _id: reportData?.job?.property },
      category: elementData?.category,
      attachments: elementData?.attachments,
    };
    if (newData?.attachments?.length === 0) delete newData.attachments;
    if (action === 'Create an issue') {
      props.setOpenIssueDialog(true);
      props.setElementId(id);
      props.setSelectedIssueData(newData);
    } else if (action === 'Approve This Issue') {
      // const data = {
      //   elementId,
      //   reportId: props.reportId,
      // };
      // props.confirmIssue(data, (err) => {
      //   props.onError(err);
      // });
      props.setIsApproveIssue(true);
      props.setOpenIssueDialog(true);
      props.setSelectedIssueData({
        ...newData,
        reportId: reportData?._id,
        elementId: subElementId ? subElementId : elementId,
      });
    }
  };

  const handleDropdown = async (relation, value) => {
    const newReportElements = reportData?.reportElements.map((i, ind) => {
      if (ind === index) {
        i[relation] = value;
      }
      return i;
    });
    await updateData(newReportElements);
  };

  const onChangeSwitch = async (relation) => {
    const newReportElements = reportData?.reportElements.map((i, ind) => {
      if (ind === index) {
        i[relation] = !i[relation];
      }
      return i;
    });
    await updateData(newReportElements);
  };

  const onClickNewMedia = (type, index, item) => {
    onClickOpenNewMediaDialog(type, index, item);
  };

  const onMediaActionClick = (action, imgId, mainIndex, tags) => {
    onClickReportMediaMenuClick(
      'outerData',
      action,
      imgId,
      mainIndex,
      '',
      tags
    );
  };

  return (
    <div className={classes.information_container}>
      {(!isClient(paramJobId) && isEditReport )&& (
        <div
          className={classNames(
            classes.information_title_container,
            data?.elements?.length === 0 && classes.information_title_container1
          )}
          // onClick={() => handleOpenInformation()}
        >
          <div className={classes.flex_view}>
            {/* <img
          className={classes.toggle_arrow}
          src={icons(theme).downArrow}
          // src={
          //   openInformation.findIndex((item) => item === index) !== -1
          //     ? icons(theme).downArrow
          //     : icons(theme).rightArrow
          // }
          alt=''
          // onClick={() => handleOpenInformation()}
        /> */}
            <label htmlFor='information' className={classes.information_title}>
              {data?.title}
            </label>
          </div>
          <div
            className={classNames(
              classes.information_title_sub_content,
              data?.elements?.length === 0 &&
                classes.information_title_sub_content1
            )}
          >
            {/* {data?.elements && data?.elements?.length > 0 && (
          <label className={classes.text_common}>
            {data?.elements?.length + ' ' + Strings.ITEMS}
          </label>
        )} */}
            {!data?.issueConfirmed &&
              data?.elements &&
              data?.elements?.length === 0 &&
              data?.issueCount > 0 &&
              !paramJobId && (
                <ReportActionMenu
                  id={''}
                  confirmed={data.issueConfirmed}
                  onSelect={(action, id) => {
                    handleOnAction(action, id, data._id);
                  }}
                />
              )}
            {data?.issueCount > 0 && data?.elementType !== 'Group' && (
              <label
                className={classNames(
                  classes.issue_container,
                  data?.issueCount > 0 && classes.red_issue_container
                )}
                style={{ cursor: 'pointer', textAlign: 'center' }}
              >
                {`${
                  data?.issueCount +
                  ' ' +
                  Strings.ISSUES +
                  (data.issueConfirmed ? ' ' + Strings.APPROVED : '')
                }`}
              </label>
            )}
            {/* {isClient(paramJobId) &&
              data?.options?.length > 0 &&
              data?.options
                ?.filter((i) => i.selected)
                .map((x) => (
                  <label
                    className={classNames(classes.client_issue_container)}
                    style={{
                      cursor: 'pointer',
                      textAlign: 'center',
                      background: x.color || '#ED4242',
                      // maxWidth: 200,
                    }}
                  >
                    {x?.option}
                  </label>
                ))} */}
          </div>
        </div>
      )}
      {(isClient(paramJobId) || !isEditReport)  && (
        <
          // className={classNames(
          //   classes.information_title_container,
          //   data?.elements?.length === 0 && classes.information_title_container1
          // )}
        >
          {data?.elementType === 'Group' && (
            <div className={classes.client_info_title_containeer}>
              <label
                htmlFor='information'
                className={classes.client_information_title}
              >
                {data?.title ? data?.title : ''}
              </label>
            </div>
          )}

          <div className={classNames(classes.client_info_sub_content)}>
            {data?.elementType !== 'Group' && (
              <div
                className={classes.client_information_data_title_container}
                style={{
                  borderTop: `1px solid ${theme.palette.background_border}`,
                  paddingBottom:
                    data?.notes ||
                    data?.issueConfirmed ||
                    data?.attachments.length > 0
                      ? 15
                      : 0,
                }}
              >
                <label
                  className={classNames(
                    classes.client_information_common_title,
                    classes.margin_left_20
                  )}
                  style={{
                    marginRight: 15,
                    fontWeight: 600,
                    alignSelf: 'center',
                    paddingTop: data?.options?.length === 0 && 8,
                    paddingBottom: data?.options?.length === 0 && 8,
                  }}
                >
                  {data.title ? data.title : ''}
                </label>
                <div
                  className={classes.flex_view}
                  style={{
                    flexDirection: 'column',
                  }}
                >
                  {data?.options?.length > 0 &&
                    data?.options
                      ?.filter((i) => i.selected)
                      .map((x) => (
                        <label
                          className={classNames(classes.client_issue_container)}
                          style={{
                            cursor: 'pointer',
                            textAlign: 'center',
                            background: x.color || '#ED4242',
                            // maxWidth: 200,
                          }}
                        >
                          {x?.option}
                        </label>
                      ))}
                </div>
              </div>
            )}
            {data?.elementType === 'Group' &&
              data?.options?.length > 0 &&
              data?.options
                ?.filter((i) => i.selected)
                .map((x) => (
                  <label
                    className={classNames(classes.client_issue_container)}
                    style={{
                      cursor: 'pointer',
                      textAlign: 'center',
                      background: x.color || '#ED4242',
                      // maxWidth: 200,
                    }}
                  >
                    {x?.option}
                  </label>
                ))}
            {data?.issueConfirmed && (
              <div className={classes.issue_confirmed_container}>
                <img src={icons().redFlagIcon} />
                <label
                  className={classes.text_dark_blue}
                  style={{ fontSize: 13 }}
                >
                  {Strings?.ITEM_ADDED_TO_ISSUES_MODULE?.toUpperCase()}
                </label>
              </div>
            )}
            <div
              className={classes.client_report_elements_container}
              style={{
                paddingBottom:
                  data?.notes || data?.attachments.length > 0 ? 15 : 0,
              }}
            >
              <div
                className={classNames(
                  classes.client_detail_section,
                  classes.detail_width
                )}
              >
                {data?.notes && (
                  <div className={classes.client_notes_margin_btm}>
                    <ReportPropertyData
                      title={Strings.NOTES}
                      value={data?.notes}
                      classContainer={classes.client_report_property_container}
                    />
                  </div>
                )}
                <MediaImageContainer
                  imageArray={data?.attachments}
                  imageData={props?.imageData}
                  itemsPerRow={isMobileView ? 2 : isTabletView ? 3 : 5}
                  lg={3}
                  xl={1.5}
                  handleMediaActionClick={(action, imgId, tags) => {
                    onMediaActionClick(action, imgId, index, tags);
                  }}
                  isEditReport={isEditReport}
                  paramJobId={paramJobId}
                />
              </div>
            </div>
            {data?.elements?.length > 0 && (
              <InformationBox
                data={data?.elements}
                imageData={props?.imageData}
                actionOnClick={(action, id, subElementId) =>
                  handleOnAction(action, id, data?._id, subElementId, true)
                }
                reportId={props.reportId}
                reportData={reportData}
                updateReportData={updateReportData}
                reportElementsIndex={index}
                isEditReport={isEditReport}
                onClickOpenNewMediaDialog={onClickOpenNewMediaDialog}
                onClickReportMediaMenuClick={onClickReportMediaMenuClick}
                paramJobId={paramJobId}
                vendorCategoryList={vendorCategoryList}
              />
            )}
          </div>
        </>
      )}
      {(!isClient(paramJobId) && isEditReport) && (
        <>
          {(data?.title !== '' || isEditReport || paramJobId) &&
            !isClient(paramJobId) && data?.elementType !== 'Group' && (
              <div className={classes.report_elements_container}>
                <div
                  className={classes.detail_section}
                  style={{ width: isClient(paramJobId) ? '100%' : '60%' }}
                >
                  {data?.options?.length !== 0 &&
                    (data?.elementType === 'Dropdown' ||
                      data?.elementType === 'Radio' ||
                      data?.elementType === 'Check List') && ( // data?.options.some((item) => item.selected)
                      <div className={classes.issue_found_detail}>
                        <div className={classes.issue_found_list}>
                          <label className={classes.information_common_title}>
                            {'Reported'}
                          </label>
                        </div>
                        <div className={classes.issue_found_desc}>
                          <div className={classes.radio_view}>
                            <Grid
                              container
                              style={{ display: 'flex', flexWrap: 'wrap' }}
                            >
                              {data?.options?.map((item, index) => {
                                return (
                                  <Grid
                                    item
                                    xs={6}
                                    xl={4}
                                    style={{ marginBottom: 10 }}
                                  >
                                    <CustomRadioButton
                                      value={item?.option}
                                      label={item?.option}
                                      disabled={!isEditReport}
                                      checked={item?.selected && item?.option}
                                      style={{
                                        marginLeft: 10,
                                      }}
                                      onChange={(value) => {
                                        onChangeCustomRadioButton(
                                          item._id,
                                          item.option
                                        );
                                      }}
                                      containerStyle={
                                        classes.radio_containerStyle
                                      }
                                    />
                                  </Grid>
                                );
                              })}
                            </Grid>
                          </div>
                        </div>
                      </div>
                    )}
                  {data?.options?.length === 0 &&
                    data?.elementType === 'Text Input' &&
                    (data?.text || isEditReport) && (
                      <Textbox
                        onChange={(e) => onChangeTextBox(e.target.value)}
                        // name={item.relation}
                        value={data?.text ? data?.text : ''}
                        placeholder={'Type Here'}
                        disabled={!isEditReport}
                        className={classes.form_input}
                      />
                    )}

                  {data?.elementType !== 'Group' && (
                    <>
                      {(data.notes || isEditReport) && (
                        <div className={classes.issue_found_detail}>
                          <div className={classes.issue_found_list}>
                            <label className={classes.information_common_title}>
                              {'Notes'}
                            </label>
                          </div>
                          <div className={classes.issue_found_desc}>
                            <Textbox
                              onChange={(e) =>
                                onChangeTextBoxForIssueFound(
                                  e.target.value,
                                  'notes'
                                )
                              }
                              name={'notes'}
                              value={data.notes ? data.notes : ''}
                              placeholder={'Type Here'}
                              disabled={!isEditReport}
                              className={classes.form_input}
                              multiline={true}
                              rows={4}
                            />
                          </div>
                        </div>
                      )}
                      {(data?.issueFound || isEditReport) && (
                        <div className={classes.checkBoxMainContainer}>
                          <Checkbox
                            id='issueFound'
                            name='Issue Found'
                            checked={data?.issueFound}
                            containerContainerClass={classes.checkboxContainer}
                            checkboxContainerClass={classes.list_checkbox}
                            checkedContainerClass={classes.checked_checkbox}
                            onChange={(e) => {
                              if (!paramJobId && isEditReport) {
                                onChangeTextBoxForIssueFound(
                                  !data?.issueFound,
                                  'issueFound'
                                );
                              }
                            }}
                          />
                          <label className={classes.information_common_title}>
                            {'Add To Issues'}
                          </label>
                        </div>
                      )}
                    </>
                  )}
                  {data?.elementType !== 'Group' &&
                    data?.issueFound &&
                    IssueFoundDetailList.map((item) => {
                      return (
                        (data[item.relation] || isEditReport) && (
                          <div className={classes.issue_found_detail}>
                            <div className={classes.issue_found_list}>
                              <label
                                className={classes.information_common_title}
                              >
                                {item.title}
                              </label>
                            </div>
                            <div className={classes.issue_found_desc}>
                              {item.output === 'selection' && (
                                <Dropdown
                                  name={item.relation}
                                  onChange={(e) => {
                                    handleDropdown(
                                      item.relation,
                                      e.target.value
                                    );
                                  }}
                                  value={
                                    data[item.relation]
                                      ? data[item.relation]
                                      : '0'
                                  }
                                  // label={Strings.TYPE}
                                  title={Strings.SELECT_AN_OPTION}
                                  optionArray={
                                    item.relation === 'category'
                                      ? vendorCategoryList
                                      : issueTypeArray
                                  }
                                  disabled={!isEditReport}
                                />
                              )}
                              {(item.output === 'textbox' ||
                                item.output === 'textarea') && (
                                <Textbox
                                  onChange={(e) =>
                                    onChangeTextBoxForIssueFound(
                                      e.target.value,
                                      item.relation
                                    )
                                  }
                                  name={item.relation}
                                  value={
                                    data[item.relation]
                                      ? data[item.relation]
                                      : ''
                                  }
                                  placeholder={'Type Here'}
                                  disabled={!isEditReport}
                                  className={classes.form_input}
                                  multiline={
                                    item.output === 'textarea' ? true : false
                                  }
                                  rows={4}
                                />
                              )}
                              {item.output === 'toggle' && (
                                <CommonSwitch
                                  checked={
                                    data[item.relation]
                                      ? data[item.relation]
                                      : false
                                  }
                                  onChange={(e) =>
                                    onChangeSwitch(item.relation)
                                  }
                                  inputProps={{ 'aria-label': 'ant design' }}
                                  disabled={!isEditReport}
                                />
                              )}
                            </div>
                          </div>
                        )
                      );
                    })}

                </div>
                {!isClient(paramJobId) && (
                  <div className={classes.media_section}>
                    {isEditReport && (
                      <div className={classes.new_media}>
                        <div
                          onClick={() => {
                            if (isEditReport) {
                              onClickNewMedia('outerData', index, data);
                            }
                          }}
                          className={classes.new_media_container}
                        >
                          <img src={icons(theme).Plus} style={{ height: 20 }} />
                          <label className={classes.text_dark_blue}>
                            {Strings.NEW_MEDIA}
                          </label>
                        </div>
                      </div>
                    )}
                    <MediaImageContainer
                      imageArray={data?.attachments}
                      imageData={props?.imageData}
                      itemsPerRow={2}
                      sm={3}
                      md={6}
                      lg={6}
                      xl={4}
                      handleMediaActionClick={(action, imgId, tags) => {
                        onMediaActionClick(action, imgId, index, tags);
                      }}
                      isReport={true}
                      isEditReport={isEditReport}
                      paramJobId={paramJobId}
                    />
                  </div>
                )}
              </div>
            )}
          {data?.elements?.length > 0 && (
            <InformationBox
              data={data?.elements}
              imageData={props?.imageData}
              actionOnClick={(action, id, subElementId) =>
                handleOnAction(action, id, data?._id, subElementId, true)
              }
              reportId={props.reportId}
              reportData={reportData}
              updateReportData={updateReportData}
              reportElementsIndex={index}
              isEditReport={isEditReport}
              onClickOpenNewMediaDialog={onClickOpenNewMediaDialog}
              onClickReportMediaMenuClick={onClickReportMediaMenuClick}
              paramJobId={paramJobId}
              vendorCategoryList={vendorCategoryList}
            />
          )}
        </>
      )}
    </div>
  );
};

const ReportDetails = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();
  const alert = useAlert();
  let { paramJobId } = useParams();
  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));

  const [reportData, setReportData] = useState(null);
  const [copiedReportData, setCopiedReportData] = useState(null);
  const [openInformation, setOpenInformation] = useState([]);
  const [openIssueDialog, setOpenIssueDialog] = useState(false);
  const [openNewMediaDialog, setOpenNewMediaDialog] = useState(false);
  const [selectedNewMedia, setSelectedNewMedia] = useState({});
  const [selectedIndexDataForMedia, setSelectedIndexDataForMedia] = useState(
    {}
  );
  const [selectedElementId, setSelectedElementId] = useState('');
  const [isEditReport, setIsEditReport] = useState(false);
  const [showMediaDialog, setShowMediaDialog] = useState(false);
  const [selectedReportMediaMenuData, setSelectedReportMediaMenuData] =
    useState({});
  const [removeImgArr, setRemoveImgArr] = useState([]);
  const [selectedIssueData, setSelectedIssueData] = useState(null);
  const [isApproveIssue, setIsApproveIssue] = useState(false);
  const [sendReportDialog, setSendReportDialog] = useState(false);
  const [vendorCategoryList, setVendorCategoryList] = useState([]);

  const dispatch = useDispatch();

  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  useEffect(() => {
    props.fetchCategoryList('vendor', (err) => onError(err));
  }, []);

  useEffect(() => {
    const data = props.categoryListData ? props.categoryListData : [];
    const newData =
      data?.map((item) => {
        const tempData = {
          title: item.categoryName,
          value: item._id,
        };
        return tempData;
      }) || [];
    setVendorCategoryList(newData);
  }, [props.categoryListData]);

  const updateData = (reportElements) => {
    const newReportData = {
      ...reportData,
      reportElements: reportElements,
    };
    setReportData(newReportData);
  };

  useEffect(() => {
    if (selectedNewMedia.length > 0) {
      if (selectedIndexDataForMedia.type === 'outerData') {
        const newReportElements = reportData?.reportElements?.map(
          (item, index) => {
            if (
              index === selectedIndexDataForMedia.index ||
              index === selectedIndexDataForMedia.mainIndex
            ) {
              if (selectedIndexDataForMedia?.isReplace) {
                let newImages = item.attachments.map((imgs) => {
                  if (imgs._id === selectedIndexDataForMedia.imgId) {
                    imgs.url = selectedNewMedia[0].url;
                    imgs._id = selectedNewMedia[0]._id;
                    imgs.type = selectedNewMedia[0].type;
                    imgs.size = selectedNewMedia[0].size;
                    imgs.fileName = selectedNewMedia[0].fileName;
                  }
                  return imgs;
                });
                item['attachments'] = newImages;
                setRemoveImgArr((oldArr) => [
                  ...oldArr,
                  selectedIndexDataForMedia.imgId,
                ]);
              } else {
                item?.attachments.push(...selectedNewMedia);
              }
            }
            return item;
          }
        );
        updateData(newReportElements);
      } else if (selectedIndexDataForMedia.type === 'innerData') {
        if (!selectedIndexDataForMedia?.isReplace) {
          selectedIndexDataForMedia?.item?.attachments.push(
            ...selectedNewMedia
          );
        }
        const newReportElements = reportData?.reportElements?.map(
          (item, index) => {
            if (index === selectedIndexDataForMedia.outerIndex) {
              if (selectedIndexDataForMedia?.isReplace) {
                let newElements = item.elements.map((innerItem, innerIndex) => {
                  if (
                    innerIndex === selectedIndexDataForMedia.index ||
                    innerIndex === selectedIndexDataForMedia.mainIndex
                  ) {
                    setRemoveImgArr((oldArr) => [
                      ...oldArr,
                      selectedIndexDataForMedia.imgId,
                    ]);
                    let newImages = innerItem.attachments.map((imgs) => {
                      if (imgs._id === selectedIndexDataForMedia.imgId) {
                        imgs.url = selectedNewMedia[0].url;
                        imgs._id = selectedNewMedia[0]._id;
                        imgs.type = selectedNewMedia[0].type;
                        imgs.size = selectedNewMedia[0].size;
                        imgs.fileName = selectedNewMedia[0].fileName;
                      }
                      return imgs;
                    });
                    innerItem['attachments'] = newImages;
                  }
                  return innerItem;
                });
                item = { ...item, elements: newElements };
              } else {
                let newElements = item.elements.map((innerItem, innerIndex) => {
                  if (innerIndex === selectedIndexDataForMedia.index) {
                    innerItem = selectedIndexDataForMedia.item;
                  }
                  return innerItem;
                });
                item = { ...item, elements: newElements };
              }
            }
            return item;
          }
        );
        updateData(newReportElements);
      }
    }
  }, [selectedNewMedia]);

  const fetchReportData = () => {
    props.getReport(
      state?.jobId || paramJobId,
      (err) => {
        onError(err);
        navigate('/app/jobs');
      },
      paramJobId ? true : false
    );
  };

  useEffect(() => {
    if ((state && state?.jobId) || paramJobId) {
      fetchReportData();
    } else {
      navigate(-1);
    }
  }, [state, paramJobId, props.confirmIssueData, props.markAsCompleteJobData]);

  useEffect(() => {
    if (props.updateReportData !== null) {
      fetchReportData();
      dispatch(setUpdateReport(null));
    }
  }, [props.updateReportData]);

  useEffect(() => {
    if (props.getReportData) {
      setReportData(JSON.parse(JSON.stringify(props.getReportData)));
      setCopiedReportData(JSON.parse(JSON.stringify(props.getReportData)));
    }
  }, [props.getReportData]);

  useEffect(() => {
    if (!isEditReport) {
      if (props.getReportData && Object.entries(props.getReportData)?.length) {
        const newData = structuredClone(props.getReportData);
        const newElementData = newData?.reportElements?.filter((el) => {
          if (el?.elementType === 'Text Input') {
            if (el?.text && el?.text !== undefined && el?.text !== null)
              return el;
          } else if (el?.options?.length) {
            const isAnyOptionSelect =
              el?.options?.some((o) => o?.selected === true) || false;
            if (isAnyOptionSelect) return el;
          } else if (el?.elements?.length) {
            const newChildElement = el?.elements?.filter((o) => {
              if (o?.elementType === 'Text Input') {
                if (o?.text && o?.text !== undefined && o?.text !== null)
                  return o;
              } else if (o?.options?.length) {
                const isAnyOptionSelect =
                  o?.options?.some((elm) => elm?.selected === true) || false;
                if (isAnyOptionSelect) return o;
              }
            });
            el.elements = newChildElement;
            return el;
          }
        });
        setReportData({
          ...props.getReportData,
          reportElements: newElementData,
        });
      }
    } else {
      let newData = structuredClone(props.getReportData);
      setReportData(newData);
    }
  }, [isEditReport, props.getReportData]);

  const imageDetails = () => {
    return {
      jobId: reportData?.job?._id,
      title: reportData?.auditTitle,
      clientName: reportData?.client?.name,
      createdBy: reportData?.createdBy?.name,
      createdAt: reportData?.createdAt,
    };
  };

  const opendIndexes = (reportData) => {
    let dataIndex = [];
    reportData?.reportElements.map((item, index) => {
      dataIndex.push(index);
    });
    setOpenInformation(dataIndex);
    setTimeout(async () => {
      await createReportPdf(reportData);
    }, 1000);
  };

  const onClickDownloadReport = () => {
    let fullname = reportData?.client?.name;
    let clientName = fullname.split(' ').pop();
    let currentDate = moment(new Date()).format('MM/DD/YYYY');
    let fileName = clientName + '-' + currentDate;
    props.downloadReport(reportData._id, fileName, paramJobId, onError);
  };

  const createReportPdf = async (reportData) => {
    let fullname = reportData?.client?.name;
    let clientName = fullname.split(' ').pop();
    const dataHeight = document.getElementById('report').scrollHeight + 80;
    html2canvas(document.getElementById('report'), {
      allowTaint: true,
      useCORS: true,
      logging: false,
      height: dataHeight,
      windowHeight: dataHeight,
    }).then((canvas) => {
      var imgData = canvas.toDataURL('image/png');
      /*
      Here are the numbers (paper width and height) that I found to work.
      It still creates a little overlap part between the pages, but good enough for me.
      if you can find an official number from jsPDF, use them.
      */
      var imgWidth = 210;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;

      var doc = new jsPDF('p', 'mm');
      var position = 0;

      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      let currentDate = moment(new Date()).format('MM/DD/YYYY');
      doc.save(`${clientName + '-' + currentDate}.pdf`);
    });
  };

  const onClickUpdate = () => {
    const data = {
      auditTitle: reportData.auditTitle,
      conductedOn: reportData.conductedOn,
      issueCount: reportData.issueCount,
      reportElements: reportData.reportElements,
      deleteFiles: removeImgArr,
    };
    const id = reportData._id;
    props.updateReport(id, data, onError, () => {
      setIsEditReport(false);
      setRemoveImgArr([]);
      setSelectedNewMedia({});
      setSelectedIndexDataForMedia({});
    });
  };

  const onClickOpenNewMediaDialog = (type, index, item, outerIndex) => {
    setOpenNewMediaDialog(true);
    const data = {
      type,
      index,
      item,
      outerIndex: outerIndex || null,
    };
    setSelectedIndexDataForMedia(data);
  };

  const onClickReportMediaMenuClick = (
    type,
    action,
    imgId,
    mainIndex,
    outerIndex,
    tags
  ) => {
    const data = {
      type,
      action,
      imgId,
      mainIndex,
      outerIndex,
      tags,
    };
    if (action === 'Replace') {
      data.isReplace = true;
      setOpenNewMediaDialog(true);
      setSelectedIndexDataForMedia(data);
    } else {
      setSelectedReportMediaMenuData(data);
      setShowMediaDialog(true);
    }
  };

  const updateReportData = (data) => {
    setReportData(data);
  };

  const deleteMediaFromReport = () => {
    if (selectedReportMediaMenuData.type === 'outerData') {
      const newReportElements = reportData?.reportElements?.map(
        (item, index) => {
          if (index === selectedReportMediaMenuData.mainIndex) {
            const newImages = item.attachments.filter(
              (imgs) => imgs._id !== selectedReportMediaMenuData.imgId
            );
            setRemoveImgArr((oldArr) => [
              ...oldArr,
              selectedReportMediaMenuData.imgId,
            ]);
            item['attachments'] = newImages;
          }
          return item;
        }
      );
      updateData(newReportElements);
    } else if (selectedReportMediaMenuData.type === 'innerData') {
      const newReportElements = reportData?.reportElements?.map(
        (item, index) => {
          if (index === selectedReportMediaMenuData.outerIndex) {
            let newElements = item.elements.map((innerItem, innerIndex) => {
              if (innerIndex === selectedReportMediaMenuData.mainIndex) {
                const newImages = innerItem.attachments.filter(
                  (imgs) => imgs._id !== selectedReportMediaMenuData.imgId
                );
                innerItem['attachments'] = newImages;
                setRemoveImgArr((oldArr) => [
                  ...oldArr,
                  selectedReportMediaMenuData.imgId,
                ]);
              }
              return innerItem;
            });
            item = { ...item, elements: newElements };
          }
          return item;
        }
      );
      updateData(newReportElements);
    }
    setShowMediaDialog(false);
  };

  const onClickMarkAsComplete = () => {
    setSendReportDialog(true);
    // props.markAsCompleteJob(state?.jobId, onError);
  };

  return (
    <>
      <div className={classes.report_container} id='report'>
        {props.getReportLoading ? (
          <div className={classes.flexView}>
            <CircularProgress
              style={{
                color: theme.palette.background_button,
              }}
            />
          </div>
        ) : (
          <>
            {!reportData ? (
              <div className={classes.flexView}>
                <p className={classes.no_data_message}>
                  {Strings.NO_DATA_FOUND}
                </p>
              </div>
            ) : (
              <>
                <TableToolbox
                  isBack={paramJobId ? false : true}
                  isLabel
                  isEdit={paramJobId ? false : true}
                  editing={isEditReport}
                  // isEdit={isAdmin() ? true : false}
                  isDownloadPdf={true}
                  // isDownloadCsv
                  markAsComplete={
                    !paramJobId && reportData?.job?.jobStatus !== 'Completed'
                      ? true
                      : false
                  }
                  markAsCompleteLoading={props.markAsCompleteJobLoading}
                  markAsCompleteDisable={props.markAsCompleteJobLoading}
                  onClickMarkAsComplete={onClickMarkAsComplete}
                  labelText={!isMobileView && reportData?.job?.title}
                  onClickBack={() => navigate(-1)}
                  onEditClick={() => {
                    setIsEditReport(true);
                  }}
                  // onDownloadPdfClick={() => opendIndexes(reportData)}
                  onDownloadPdfClick={() => onClickDownloadReport()}
                  downloadPdfLoader={props.downloadReportLoading}
                  onClickCancel={() => {
                    setIsEditReport(false);
                    setReportData(JSON.parse(JSON.stringify(copiedReportData)));
                    setRemoveImgArr([]);
                    setSelectedNewMedia({});
                    setSelectedIndexDataForMedia({});
                  }}
                  onClickSaveUpdates={onClickUpdate}
                  updateReportLoading={props.updateReportLoading}
                  // onDownloadCsvClick={() => {}}
                />
                {isMobileView && (
                  <label className={classes.toolbar_title}>
                    {reportData?.job?.title}
                  </label>
                )}
                <div className={classes.properties_container}>
                  <div className={classes.report_details}>
                    <ReportPropertyData
                      title={Strings.AUDIT_TITLE}
                      value={reportData?.auditTitle}
                      isEditReport={isEditReport}
                      reportData={reportData}
                      updateReportData={updateReportData}
                    />
                    <ReportPropertyData
                      title={Strings.CLIENT}
                      value={reportData?.client?.name}
                    />
                    <ReportPropertyData
                      title={Strings.PREPARED_BY}
                      value={reportData?.createdBy?.name}
                    />
                    <ReportPropertyData
                      title={Strings.CONDUCTED_ON}
                      value={
                        reportData?.conductedOn &&
                        moment(reportData?.conductedOn).format('MMM DD, YYYY') +
                          ' at ' +
                          moment(reportData?.conductedOn).format('hh:mm a')
                      }
                      datePickerValue={
                        reportData?.conductedOn &&
                        moment(reportData?.conductedOn).format('MMM DD, YYYY')
                      }
                      isEditReport={isEditReport}
                      reportData={reportData}
                      updateReportData={updateReportData}
                    />
                    <ReportPropertyData
                      title={Strings.ISSUES}
                      value={
                        reportData?.issueCount
                          ? reportData?.issueCount
                          : Strings.NO_ISSUES_FOUND
                      }
                    />
                    {isSuperAdmin() && (
                      <ReportPropertyData
                        title={Strings.VIEWED_BY_CLIENT}
                        value={
                          reportData?.job?.ViewByClient
                            ? `Yes, on ${moment(
                                reportData?.job?.ViewByClient
                              ).format('MMM DD, YYYY')}`
                            : `No`
                        }
                      />
                    )}
                    {/* {isAdmin() && (
                      <div className={classes.reports_actions_container}>
                        <Button
                          text={Strings.APPROVE}
                          className={classes.action_button}
                          onClick={() => {}}
                        />
                        <Button
                          text={Strings.APPROVE_AND_SEND}
                          className={classes.action_button}
                          onClick={() => {}}
                        />
                      </div>
                    )} */}
                  </div>
                </div>
                <div
                  className={classes.report_view_container}
                  id='report-child'
                >
                  {reportData?.reportElements?.map((item, index) => {
                    const isShow =
                      (item.elementType === 'Group' &&
                        item?.elements?.length) ||
                      item.elementType !== 'Group';
                    if (isShow) {
                      return (
                        <ReportInformation
                          key={index}
                          index={index}
                          data={item}
                          paramJobId={paramJobId}
                          openInformation={openInformation}
                          setOpenInformation={setOpenInformation}
                          setOpenIssueDialog={setOpenIssueDialog}
                          setElementId={setSelectedElementId}
                          imageData={imageDetails()}
                          reportId={reportData._id}
                          confirmIssue={props.confirmIssue}
                          onError={onError}
                          reportData={reportData}
                          updateReportData={updateReportData}
                          isEditReport={isEditReport}
                          onClickOpenNewMediaDialog={onClickOpenNewMediaDialog}
                          onClickReportMediaMenuClick={
                            onClickReportMediaMenuClick
                          }
                          setSelectedIssueData={setSelectedIssueData}
                          setIsApproveIssue={setIsApproveIssue}
                          vendorCategoryList={vendorCategoryList}
                        />
                      );
                    }
                  })}
                  {reportData?.linkedIssues?.length > 0 && (
                    <>
                      <div
                        className={classNames(
                          classes.information_title_container,
                          classes.information_title_container1
                        )}
                      >
                        <div className={classes.flex_view}>
                          <label
                            htmlFor='information'
                            className={classes.information_title}
                            style={{ marginBottom: 10 }}
                          >
                            {'Summary of Issues'}
                          </label>
                        </div>
                      </div>
                      <div className={classes.related_issue_container}>
                        {reportData?.linkedIssues?.map((item, index) => {
                          return (
                            <div className={classes.related_issues}>
                              <label
                                className={classes.information_common_title}
                              >
                                {item?.issue?.issueTitle}
                              </label>
                              {item?.issue?.description && (
                                <>
                                  <label
                                    className={classes.text_dark_blue}
                                    style={{
                                      fontSize: 14,
                                      marginTop: 10,
                                      marginBottom: 10,
                                    }}
                                  >
                                    {Strings.ISSUE_SUMMARY}
                                  </label>
                                  <label className={classes.text_common}>
                                    {item?.issue?.description || '-'}
                                  </label>
                                </>
                              )}

                              {item?.notes && (
                                <>
                                  <label
                                    className={classes.text_dark_blue}
                                    style={{
                                      fontSize: 14,
                                      marginTop: 10,
                                      marginBottom: 10,
                                    }}
                                  >
                                    {Strings.COMMENTS_AND_HISTORY}
                                  </label>
                                  <label className={classes.text_common}>
                                    {item?.notes?.note || '-'}
                                  </label>
                                </>
                              )}

                              {item?.internalNotes && !paramJobId && (
                                <>
                                  <label
                                    className={classes.text_dark_blue}
                                    style={{
                                      fontSize: 14,
                                      marginTop: 10,
                                      marginBottom: 10,
                                    }}
                                  >
                                    {Strings.INTERNAL_NOTES}
                                  </label>
                                  <label className={classes.text_common}>
                                    {item?.internalNotes?.note || '-'}
                                  </label>
                                </>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
      {openIssueDialog && (
        <NewIssue
          onClose={() => {
            setOpenIssueDialog(false);
            setSelectedElementId('');
            setSelectedIssueData(null);
            setIsApproveIssue(false);
          }}
          isNewIssue={isApproveIssue ? false : true}
          isApproveIssue={isApproveIssue}
          fetchedIssueData={isApproveIssue ? selectedIssueData : {}}
        />
      )}

      {openNewMediaDialog && (
        <UploadFileWithTagsDialog
          onClose={() => setOpenNewMediaDialog(false)}
          reportId={reportData._id}
          setSelectedNewMedia={setSelectedNewMedia}
          selectedIndexDataForMedia={selectedIndexDataForMedia}
        />
      )}

      {showMediaDialog && (
        <CommonDialog
          title={'Media'}
          message={'Are you sure you want to delete this media?'}
          onSuccess={() => deleteMediaFromReport()}
          onClose={() => {
            setShowMediaDialog(false);
          }}
        />
      )}

      {sendReportDialog && !isClient(paramJobId) && (
        <SendReport
          selectedJobId={state?.jobId || paramJobId}
          onNewClose={() => setSendReportDialog(false)}
          client={reportData?.client?.email}
          isReviewReport={false}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  getReportData: state.getReportData.data,
  getReportLoading: state.getReportData.loading,
  markAsCompleteJobLoading: state.markAsCompleteJobData.loading,
  markAsCompleteJobData: state.markAsCompleteJobData.data,

  confirmIssueData: state.confirmIssueData.data,
  updateReportData: state.updateReportData.data,
  updateReportLoading: state.updateReportData.loading,
  downloadReportLoading: state.downloadReportData.loading,

  categoryListData: state.categoryListData.data,
});

export default connect(mapStateToProps, {
  getReport,
  confirmIssue,
  updateReport,
  downloadReport,
  markAsCompleteJob,
  fetchCategoryList,
})(ReportDetails);
